import {
  Input,
  message,
  Popconfirm,
  Upload,
  Select,
  PageHeader,
  Spin,
  Row,
  Col,
  Form as FormInitial,
  Space,
  Alert,
  Tag,
} from "antd";
import {
  DeleteOutlined,
  UploadOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  FilePdfOutlined,
  CheckOutlined
} from "@ant-design/icons";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ModalItem,
  DatePickerItem,
  InputNumberItem,
  SelectItem,
  InputItem,
  ButtonItem,
  TextAreaItem,
  cuentaMask,
  SwitchItem,
  CheckItem,
  round6Decimals,
  dineroDisabledMask,
  SelectInsumosItem,
  round2Decimals,
  ErrorItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import AgregarUnidad from "../../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";
import moment from "moment";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import VerPdf from "./VerPdf/VerPdf";
import { TIPOS_MATRIZ } from "../matriz.utils";
import ProduccionMatriz from "../ProduccionMatriz/ProduccionMatriz";
import { minutosAUnidad, unidadAMinutos } from "../../PresupuestosPU/OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class MatrizForm extends Component {
  formRef = React.createRef();
  esNuevo = !this.props.location?.state?.id;
  state = {
    loading: false,
    buscarInfoCode: false,
    archivosPrincipal: [],
    archivosTecnica: [],
    archivosFotos: [],
    archivosInstrucciones: [],
    todasMonedas: null,
    objetoMonedas: null,
    todasUnidades: null,
    objetoUnidades: null,
    todasImpuestos: null,
    objetoImpuestos: null,
    todasFamilia: null,
    objetoFamilia: null,
    todasProveedores: null,
    objetoProveedores: null,
    todasGrupoSat: null,
    objetoGrupoSat: null,
    todasClaseSat: null,
    objetoClaseSat: null,
    todasCodigoSat: null,
    objetoCodigoSat: null,
    todasRetenciones: null,
    objetoRetenciones: null,
    objetoInsumos: null,
    todasInsumos: [],
    modalAgregarUnidad: false,
    modalAgregarFamilia: false,
    precios: [],
    calcularPreciosAutomaticamente: false,
    calcularPreciosSobre: false,
    utilizado: false,
    autorizado: false,
    superado: false,
    versionNumero: 1,
    versiones: [],
    impuestoCombustible: false,
    modalAgregarCuentaContable: false,
    todasCuentasContablesFinales: null,
    objetoCuentasContablesFinales: null,
    todasMaterialesPeligrosos: null,
    objetoMaterialesPeligrosos: null,
    todasEmbalajes: null,
    objetoEmbalajes: null,
    todasSectoresCOF: null,
    objetoSectoresCOF: null,
    todasFormasFarmaceuticas: null,
    objetoFormasFarmaceuticas: null,
    todasCondicionesEspeciales: null,
    objetoCondicionesEspeciales: null,
    todasTiposMaterias: null,
    objetoTiposMaterias: null,
    id: this.props.location?.state?.id,
    costoMatriz: 0,
    costoMatrizMaximo: 0,
    costoMatrizMinimo: 0,
    costoMatrizPromedio: 0,
    modalMatriz: false,
    modalMatrizId: null,
    loadingEnvios: false,
    objetoTipoDeInsumo: null,
    todasTipoDeInsumo: [],
  };
  atras() {
    this.props.history.goBack();
  }

  cerrarModalPdf() {
    this.setState({ modalMatriz: false, modalMatrizId: null });
  }

  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo(e) {
    this.setState({ loading: true });
    let preciosConfig;
    await axios
      .post(
        "matrices/selectDatosParaMatriz",
        { empresaId: this.props.empresaId, insumoId: this.state.id },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          preciosConfig = res.data.configuracion.precios.map((value) => {
            return {
              porcentaje: value.porcentaje,
              nombre: value.nombre,
              precioId: value._id,
            };
          });
          this.setState(
            {
              todasGrupoSat: res.data.subclases,
              todasProveedores: res.data.proveedores,
              todasRetenciones: res.data.retenciones,
              todasImpuestos: res.data.impuestos,
              todasFamilia: res.data.familias,
              todasTipoDeInsumo: res.data.tiposInsumos,
              todasMonedas: res.data.monedas,
              todasUnidades: res.data.unidades,
              todasInsumos: res.data.insumos,
              calcularPreciosAutomaticamente:
                res.data.configuracion.calcularPreciosAutomaticamente,
              calcularPreciosSobre: res.data.configuracion.calcularPreciosSobre,
              objetoUnidades: res.data.unidades.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.unidadSat.c_ClaveUnidad +
                      " - " +
                      (value.descripcion
                        ? value.nombre + " - " + value.descripcion
                        : value.nombre)}
                  </Option>
                );
              }),
              objetoMonedas: res.data.monedas.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre + " - " + value.abreviacion}
                  </Option>
                );
              }),
              objetoFamilia: res.data.familias.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoImpuestos: res.data.impuestos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoRetenciones: res.data.retenciones.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              objetoProveedores: res.data.proveedores.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                  </Option>
                );
              }),
              objetoGrupoSat: res.data.subclases.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.codigo + " - " + value.descripcion}
                  </Option>
                );
              }),
              objetoTipoDeInsumo: res.data.tiposInsumos.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
              precios: res.data.configuracion.precios.map((value) => {
                return {
                  porcentaje: value.porcentaje,
                  nombre: value.nombre,
                  precioId: value._id,
                };
              }),
            },
            () => {
              this.formRef.current.setFieldsValue({
                codigo: res.data.sigNumero,
                clave: res.data.sigNumero,
                precios: res.data.configuracion.precios.map((value) => {
                  return {
                    porcentaje: value.porcentaje,
                    nombre: value.nombre,
                    precioId: value._id,
                  };
                }),
              });
            },
          );
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentasContablesFinales: res.data });
          this.setState({
            objetoCuentasContablesFinales: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                      value.nivel2 +
                      value.nivel3 +
                      value.nivel4 +
                      value.nivel5,
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    if (!this.esNuevo && !e) {
      let datosInsumo;
      await axios
        .post(
          "matrices/datosMatriz",
          { empresaId: this.props.empresaId, insumoId: this.state.id },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la matriz");
          } else {
            if (res.data.utilizado) {
              message.info(
                "No se puede modificar toda la informacion ya que la matriz ya fue utilizada",
              );
            }
            datosInsumo = res.data;
            let costoMatriz = 0;
            let costoMatrizMaximo = 0;
            let costoMatrizMinimo = 0;
            let costoMatrizPromedio = 0;

            const nuevosInsumosUtilizar = res.data.insumosUtilizar.map(
              (insumoU) => {
                if (insumoU.insumoId && insumoU.cantidad) {
                  const insumo = this.state.todasInsumos.find(
                    (valueTI) =>
                      valueTI._id.toString() === insumoU.insumoId.toString(),
                  );

                  if (insumo) {
                    if (insumo.costo) {
                      const {
                        costoInsumo,
                        costoMaximo,
                        costoMinimo,
                        costoPromedio,
                      } = this.calcularCostoInsumo(
                        insumo,
                        insumoU,
                        datosInsumo.metodoCosteoGeneral,
                      );

                      costoMatriz += round6Decimals(
                        costoInsumo * insumoU.cantidad,
                      );
                      costoMatrizMaximo += round6Decimals(
                        costoMaximo * insumoU.cantidad,
                      );
                      costoMatrizMinimo += round6Decimals(
                        costoMinimo * insumoU.cantidad,
                      );
                      costoMatrizPromedio += round6Decimals(
                        costoPromedio * insumoU.cantidad,
                      );

                      return {
                        ...insumoU,
                        costo: costoInsumo,
                        costoTotal: round6Decimals(
                          costoInsumo * insumoU.cantidad,
                        ),
                      };
                    } else {
                      costoMatriz += insumoU.costoTotal;
                      costoMatrizMaximo += insumoU.costoTotal;
                      costoMatrizMinimo += insumoU.costoTotal;
                      costoMatrizPromedio += insumoU.costoTotal;

                      return {
                        ...insumoU,
                        costo: insumoU.costo,
                        costoTotal: insumoU.costoTotal,
                      };
                    }
                  } else {
                    message.warning(
                      "Insumo no encontrado en insumos a utilizar",
                    );
                    return insumoU;
                  }
                } else {
                  return insumoU;
                }
              },
            );

            this.formRef.current.setFieldsValue({
              ...res.data,
              precios: preciosConfig.map((precioC) => {
                let precioA = res.data.precios.find(
                  (valueA) =>
                    valueA.precioId?.toString() === precioC.precioId.toString(),
                );
                if (precioA) {
                  return precioA;
                } else {
                  return precioC;
                }
              }),
              equivalencias: res.data.equivalencias
                ? res.data.equivalencias.map((valueEquiv) => {
                    const preciosEquiv = preciosConfig.map((precioC) => {
                      let precioA = valueEquiv.precios.find(
                        (valueA) =>
                          valueA.precioId?.toString() ===
                          precioC.precioId.toString(),
                      );
                      if (precioA) {
                        return precioA;
                      } else {
                        return precioC;
                      }
                    });
                    return { ...valueEquiv, precios: preciosEquiv };
                  })
                : [],
              fechaCalculo: moment(res.data.fechaCalculo),
              tiempoCiclo: minutosAUnidad(res.data.tiempoCiclo || 0, this.props.unidadTiempoProduccion),
              insumosUtilizar: nuevosInsumosUtilizar,
              costo: round2Decimals(costoMatriz),
              costoMaximo: round2Decimals(costoMatrizMaximo),
              costoMinimo: round2Decimals(costoMatrizMinimo),
              costoPromedio: round2Decimals(costoMatrizPromedio),
            });
            this.setState({
              utilizado: res.data.utilizado,
              tipoMatriz: res.data.tipoMatriz,
              autorizado: res.data.autorizado,
              superado: res.data.superado,
              versionNumero: res.data.versionNumero,
              versiones: res.data.versiones || [],
              costoMatriz: round2Decimals(costoMatriz),
              costoMatrizMaximo: round2Decimals(costoMatrizMaximo),
              costoMatrizMinimo: round2Decimals(costoMatrizMinimo),
              costoMatrizPromedio: round2Decimals(costoMatrizPromedio),
              archivosFotos: res.data.archivosFotos.map((element) => {
                var png = element.base64;
                let mimetype =
                  element.extension !== "pdf"
                    ? "image/" + element.extension
                    : "application/pdf";
                let blob = new Blob([window.atob(png)], {
                  type: mimetype,
                  encoding: "utf-8",
                });
                let file = new File([blob], element.name, {
                  type: blob.type,
                  lastModified: new Date(),
                });
                file.path = element.path;
                file.base64 = "data:" + mimetype + ";base64," + element.base64;
                return file;
              }),
              archivosPrincipal: res.data.archivosPrincipal.map((element) => {
                var png = element.base64;
                let mimetype =
                  element.extension !== "pdf"
                    ? "image/" + element.extension
                    : "application/pdf";
                let blob = new Blob([window.atob(png)], {
                  type: mimetype,
                  encoding: "utf-8",
                });
                let file = new File([blob], element.name, {
                  type: blob.type,
                  lastModified: new Date(),
                });
                file.path = element.path;
                file.base64 = "data:" + mimetype + ";base64," + element.base64;
                return file;
              }),
              archivosTecnica: res.data.archivosTecnica.map((element) => {
                var png = element.base64;
                let mimetype =
                  element.extension !== "pdf"
                    ? "image/" + element.extension
                    : "application/pdf";
                let blob = new Blob([window.atob(png)], {
                  type: mimetype,
                  encoding: "utf-8",
                });
                let file = new File([blob], element.name, {
                  type: blob.type,
                  lastModified: new Date(),
                });
                file.path = element.path;
                file.uuid = element.path;
                file.base64 = "data:" + mimetype + ";base64," + element.base64;
                return file;
              }),
              archivosInstrucciones: (res.data.archivosInstrucciones || []).map((element) => {
                var png = element.base64;
                let mimetype =
                  element.extension !== "pdf"
                    ? "image/" + element.extension
                    : "application/pdf";
                let blob = new Blob([window.atob(png)], {
                  type: mimetype,
                  encoding: "utf-8",
                });
                let file = new File([blob], element.name, {
                  type: blob.type,
                  lastModified: new Date(),
                });
                file.path = element.path;
                file.uuid = element.path;
                file.base64 = "data:" + mimetype + ";base64," + element.base64;
                return file;
              }),
            });
          }
        });
      await axios
        .post(
          "codigoinsumos/buscarCodigoLista",
          {
            empresaId: this.props.empresaId,
            subClaseId: datosInsumo.codigoSatId,
          },
          { headers: this.props.headersToken },
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({
              todasCodigoSat: res.data,
              buscarInfoCode: false,
              objetoCodigoSat: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.c_ClaveProdServ + " - " + value.descripcion}
                  </Option>
                );
              }),
            });
          }
        });
    }
    this.setState({ loading: false });
  }

  async consultarEnvio() {
    this.setState({ loadingEnvios: true });
    await axios
      .post(
        "matrices/selectDatosParaMatrizEnvio",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            loadingEnvios: false,
            todasMaterialesPeligrosos: res.data.materialesPeligrosos,
            todasEmbalajes: res.data.embalajes,
            unidadPeso: res.data.unidadPeso,
            todasSectoresCOF: res.data.sectoresCOF,
            todasFormasFarmaceuticas: res.data.formasFarmaceuticas,
            todasCondicionesEspeciales: res.data.condicionesEspeciales,
            todasTiposMaterias: res.data.tiposMaterias,
            objetoMaterialesPeligrosos: res.data.materialesPeligrosos.map(
              (value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              },
            ),
            objetoEmbalajes: res.data.embalajes.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.Clave + " - " + value.Descripcion}
                </Option>
              );
            }),
            objetoSectoresCOF: res.data.sectoresCOF.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.Clave + " - " + value.Descripcion}
                </Option>
              );
            }),
            objetoFormasFarmaceuticas: res.data.formasFarmaceuticas.map(
              (value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              },
            ),
            objetoCondicionesEspeciales: res.data.condicionesEspeciales.map(
              (value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.Clave + " - " + value.Descripcion}
                  </Option>
                );
              },
            ),
            objetoTiposMaterias: res.data.tiposMaterias.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.Clave + " - " + value.Descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }

  onChangeGrupo(e) {
    this.formRef.current.setFieldsValue({
      claseSatId: undefined,
      codigoSatId: undefined,
    });
    axios
      .post(
        "codigoinsumos/selectClases",
        { empresaId: this.props.empresaId, grupoId: e },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClaseSat: res.data });
          this.setState({
            objetoClaseSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.codigo + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }

  onChangeClase(e) {
    this.formRef.current.setFieldsValue({ codigoSatId: undefined });
    axios
      .post(
        "codigoinsumos/selectSubclases",
        { empresaId: this.props.empresaId, claseId: e },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCodigoSat: res.data });
          this.setState({
            objetoCodigoSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_ClaveProdServ + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  renderTipoMatriz() {
    return (
      <Row>
        <Col span={8}></Col>
        <Col span={8}>
          <FormItem label="Tipo" name="tipoMatriz" margin labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
            <SelectItem placeholder="Selecciona el tipo" allowClear disabled={this.state.autorizado} onChange={(tipoMatriz) => this.setState({ tipoMatriz })}>
              {TIPOS_MATRIZ.map((tipo) => (
                <Option key={tipo.value} value={tipo.value}>
                  <Tag color={tipo.color}>{tipo.label}</Tag>
                  {tipo.descripcion}
                </Option>
              ))}
            </SelectItem>
          </FormItem>
        </Col>
      </Row>
    );
  }

  onFinish(valoresForm) {
    const values = { ...valoresForm, tiempoCiclo: unidadAMinutos(valoresForm.tiempoCiclo, this.props.unidadTiempoProduccion) };
    this.setState({ loading: true });
    let fd = new FormData();
    fd.append("empresaId", this.props.empresaId);
    if (!this.esNuevo) fd.append("insumoId", this.state.id);
    for (var key in values) {
      if (values[key] === undefined || values[key] === "") {
      } else {
        if (key === "precios") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "insumosUtilizar") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "impuestos") {
          fd.append(key, JSON.stringify(values[key]));
        } else if (key === "retenciones") {
          fd.append(key, JSON.stringify(values[key]));
        } else {
          if (values[key] !== null) {
            fd.append(key, values[key]);
          }
        }
      }
    }
    this.state.archivosPrincipal.forEach((element, index) => {
      let nombre = "archivoPrincipal" + (index + 1);
      if (element.path) nombre = "archivoPrincipal:" + element.path;
      fd.append(nombre, element);
    });
    this.state.archivosTecnica.forEach((element, index) => {
      let nombre = "archivoTecnica" + (index + 1);
      if (element.path) nombre = "archivoTecnica:" + element.path;
      fd.append(nombre, element);
    });
    this.state.archivosFotos.forEach((element, index) => {
      let nombre = "archivoFoto" + (index + 1);
      if (element.path) nombre = "archivoFoto:" + element.path;
      fd.append(nombre, element);
    });
    this.state.archivosInstrucciones.forEach((element, index) => {
      let nombre = "archivoInstruccion" + (index + 1);
      if (element.path) nombre = "archivoInstruccion:" + element.path;
      fd.append(nombre, element);
    });
    if (this.esNuevo) {
      fd.append("inventariable", false);
      fd.append("subinsumo", false);
    }
    axios
      .post(
        this.esNuevo ? "matrices/agregarMatriz" : "matrices/editarMatriz",
        fd,
        {
          headers: {
            ...this.props.headersToken,
          },
        },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            this.esNuevo
              ? "Se ha registrado una matriz"
              : "Se ha editado una matriz",
          );
          this.formRef.current.resetFields();
          this.setState({
            archivosPrincipal: [],
            archivosTecnica: [],
            archivosFotos: [],
            archivosInstrucciones: [],
          });
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.error(
            res.data.message ||
              (this.esNuevo
                ? "No se puede registrar la matriz"
                : "No se puede editar la matriz"),
          );
        } else {
          message.error(
            this.esNuevo
              ? "Hubo un error y la matriz no se registro"
              : "Hubo un error y la matriz no se edito",
          );
        }
      });
  }

  autorizarMatriz() {
    this.setState({ loading: true });
    axios
      .post(
        "matrices/autorizarMatriz",
        { insumoId: this.state.id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Matriz autorizada correctamente");
          this.consultarTodo();
        } else {
          message.error(res.data.message || "No se pudo autorizar la matriz");
        }
      });
  }

  nuevaVersionMatriz() {
    this.setState({ loading: true });
    axios
      .post(
        "matrices/clonarMatriz",
        { insumoId: this.state.id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(res.data.message || "Matriz clonada correctamente");
          this.props.history.replace("/panel/editarMatriz", {
            id: res.data.matriz._id,
          });
          this.setState({ id: res.data.matriz._id }, () =>
            this.consultarTodo(),
          );
        } else {
          message.error(
            res.data.message || "No se pudo crear la nueva versión",
          );
        }
      });
  }

  onBlurDescripcion() {
    if (!this.formRef.current.getFieldValue("descripcionLarga")) {
      let value = this.formRef.current.getFieldValue("descripcion");
      this.formRef.current.setFieldsValue({
        descripcionLarga: value,
      });
    }
  }

  customRequestFicha(e) {
    this.setState({ archivosTecnica: [...this.state.archivosTecnica, e.file] });
  }

  onRemoveFileFicha(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosTecnica");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosTecnica.indexOf(e);
    let nuevoArray = this.state.archivosTecnica;
    nuevoArray.splice(index, 1);
    this.setState({ archivosTecnica: nuevoArray });
  }

  customRequestPrincipal(e) {
    this.setState({
      archivosPrincipal: [...this.state.archivosPrincipal, e.file],
    });
  }

  onRemoveFilePrincipal(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosPrincipal");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosPrincipal.indexOf(e);
    let nuevoArray = this.state.archivosPrincipal;
    nuevoArray.splice(index, 1);
    this.setState({ archivosPrincipal: nuevoArray });
  }

  customRequestFotos(e) {
    this.setState({ archivosFotos: [...this.state.archivosFotos, e.file] });
  }

  onRemoveFileFotos(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosFotos");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosFotos.indexOf(e);
    let nuevoArray = this.state.archivosFotos;
    nuevoArray.splice(index, 1);
    this.setState({ archivosFotos: nuevoArray });
  }

  customRequestInstrucciones(e) {
    this.setState({ archivosInstrucciones: [...this.state.archivosInstrucciones, e.file] });
  }

  onRemoveFileInstrucciones(e) {
    if (e.path) {
      let fd = new FormData();
      fd.append("empresaId", this.props.empresaId);
      fd.append("insumoId", this.state.id);
      fd.append("tipo", "archivosInstrucciones");
      fd.append("archivo", e);
      fd.append("path", e.path);
    }
    let index = this.state.archivosInstrucciones.indexOf(e);
    let nuevoArray = this.state.archivosInstrucciones;
    nuevoArray.splice(index, 1);
    this.setState({ archivosInstrucciones: nuevoArray });
  }

  abrirAgregarUnidad() {
    this.setState({ modalAgregarUnidad: true });
  }
  cerrarAgregarUnidad(codigo) {
    this.setState({ modalAgregarUnidad: false });
    this.consultarTodo(true).then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ unidadId: codigo });
      }
    });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia(codigo) {
    this.setState({ modalAgregarFamilia: false });
    this.consultarTodo().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ familiaId: codigo });
      }
    });
  }
  onChangeCosto() {
    const valueCosto = this.formRef.current.getFieldValue("costo");
    if (!valueCosto) return;
    let arrayValues = this.formRef.current.getFieldValue("precios");
    let arrayNuevo = arrayValues.map((value, index) => {
      let precio;
      if (this.state.calcularPreciosSobre) {
        precio = ((valueCosto * (100 + value.porcentaje)) / 100).toFixed(2);
      } else {
        precio = (valueCosto / ((100 - value.porcentaje) / 100)).toFixed(2);
      }
      return { ...value, precio };
    });
    this.formRef.current.setFieldsValue({
      precios: arrayNuevo,
    });
  }

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }
    let preview;
    if (file.base64) {
      preview = file.base64;
    } else {
      preview = file.preview;
    }
    this.setState({
      previewImage: preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  onChangeImpuesto() {
    const impuestos = this.formRef.current.getFieldValue("impuestos");
    let combustible = false;
    let impuestoIdCombustible;
    impuestos.map((valueImpuesto) => {
      if (valueImpuesto?.impuestoId) {
        const impuesto = this.state.todasImpuestos.find(
          (valueTodasImpuesto) =>
            valueTodasImpuesto._id.toString() ===
            valueImpuesto.impuestoId.toString(),
        );
        if (impuesto.combustible) {
          combustible = true;
          impuestoIdCombustible = impuesto._id;
        }
      }
      return null;
    });
    if (combustible) {
      message.info("Si el impuesto es especial solamente se puede elegir uno");
      this.setState({ impuestoCombustible: combustible });
      this.formRef.current.setFieldsValue({
        impuestos: [{ impuestoId: impuestoIdCombustible }],
      });
    } else {
      this.setState({ impuestoCombustible: combustible });
    }
  }

  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo();
  }

  onChangeCodigo(value) {
    this.setState({ buscarInfoCode: true });
    axios
      .post(
        "codigoinsumos/buscarCodigoLista",
        { empresaId: this.props.empresaId, codigo: value },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasCodigoSat: res.data,
            buscarInfoCode: false,
            objetoCodigoSat: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_ClaveProdServ + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
  }

  onChangeVenta(e) {
    if (e) {
      if (!this.state.objetoCodigoSat) {
        this.setState({ buscarInfoCode: true });
        axios
          .post(
            "codigoinsumos/buscarCodigoLista",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken },
          )
          .then((res) => {
            if (res.data.status === 404) {
            } else {
              this.setState({
                todasCodigoSat: res.data,
                buscarInfoCode: false,
                objetoCodigoSat: res.data.map((value) => {
                  return (
                    <Option value={value._id} key={value._id}>
                      {value.c_ClaveProdServ + " - " + value.descripcion}
                    </Option>
                  );
                }),
              });
            }
          });
      }
    }
  }

  calcularCosto() {
    const insumosUtilizar =
      this.formRef.current.getFieldValue("insumosUtilizar");
    const metodoCosteoGeneral = this.formRef.current.getFieldValue(
      "metodoCosteoGeneral",
    );

    let costoMatriz = 0;
    let costoMatrizMaximo = 0;
    let costoMatrizMinimo = 0;
    let costoMatrizPromedio = 0;

    for (const insumoU of insumosUtilizar) {
      if (insumoU?.insumoId) {
        const insumo = this.state.todasInsumos.find(
          (valueTI) => valueTI._id.toString() === insumoU.insumoId.toString(),
        );

        if (insumo.costo) {
          const { costoInsumo, costoMaximo, costoMinimo, costoPromedio } =
            this.calcularCostoInsumo(insumo, insumoU, metodoCosteoGeneral);

          costoMatriz += round6Decimals(costoInsumo * (insumoU.cantidad || 0));
          costoMatrizMaximo += round6Decimals(
            costoMaximo * (insumoU.cantidad || 0),
          );
          costoMatrizMinimo += round6Decimals(
            costoMinimo * (insumoU.cantidad || 0),
          );
          costoMatrizPromedio += round6Decimals(
            costoPromedio * (insumoU.cantidad || 0),
          );
        } else {
          costoMatriz += insumoU.costoTotal;
          costoMatrizMaximo += insumoU.costoTotal;
          costoMatrizMinimo += insumoU.costoTotal;
          costoMatrizPromedio += insumoU.costoTotal;
        }
      }
    }

    this.formRef.current.setFieldsValue({
      costo: round2Decimals(costoMatriz),
      costoMaximo: round2Decimals(costoMatrizMaximo),
      costoMinimo: round2Decimals(costoMatrizMinimo),
      costoPromedio: round2Decimals(costoMatrizPromedio),
    });
    this.setState({
      costoMatriz,
      costoMatrizMaximo,
      costoMatrizMinimo,
      costoMatrizPromedio,
    });
  }

  calcularCostoInsumo(insumo, valueInsumo, metodoCosteoGeneral) {
    const metodoCosteoFinal = valueInsumo.metodoCosteo || metodoCosteoGeneral;

    let costoMaximo;
    let costoTotal;
    let cantidadTotal;
    let costoMinimo;

    for (const valueRelacion of insumo.relaciones || []) {
      if (valueRelacion.estado === 0) continue;
      const costoUnitarioPorInsumo =
        valueRelacion.costo / (valueRelacion.conversion || 1);

      if (costoUnitarioPorInsumo) {
        if (!costoMaximo || costoUnitarioPorInsumo > costoMaximo) {
          costoMaximo = costoUnitarioPorInsumo;
        }

        if (!costoMinimo || costoUnitarioPorInsumo < costoMinimo) {
          costoMinimo = costoUnitarioPorInsumo;
        }

        costoTotal = (costoTotal || 0) + costoUnitarioPorInsumo;
        cantidadTotal = (cantidadTotal || 0) + 1;
      }
    }

    let costoInsumo;

    if (metodoCosteoFinal) {
      if (metodoCosteoFinal === 1) {
        if (costoMaximo) {
          costoInsumo = costoMaximo;
        } else {
          costoInsumo = insumo.costo;
        }
      } else if (metodoCosteoFinal === 2) {
        // Promedio

        if (cantidadTotal > 0) {
          costoInsumo = round6Decimals(costoTotal / cantidadTotal);
        } else {
          costoInsumo = insumo.costo;
        }
      } else if (metodoCosteoFinal === 3) {
        //Minimo

        if (costoMinimo) {
          costoInsumo = costoMinimo;
        } else {
          costoInsumo = insumo.costo;
        }
      } else if (metodoCosteoFinal === 4) {
        // Ultimo
        costoInsumo = insumo.costo;
      }
    } else {
      costoInsumo = insumo.costo;
    }

    return {
      costoInsumo,
      costoMaximo: costoMaximo || insumo.costo,
      costoMinimo: costoMinimo || insumo.costo,
      costoPromedio:
        costoTotal && cantidadTotal
          ? round6Decimals(costoTotal / cantidadTotal)
          : insumo.costo,
    };
  }

  async onChangeInsumoCantidad(value, key, insumoEncontrado) {
    const insumosUtilizar =
      this.formRef.current.getFieldValue("insumosUtilizar");
    const metodoCosteoGeneral = this.formRef.current.getFieldValue(
      "metodoCosteoGeneral",
    );
    this.setState({ loading: true });
    const insumoId = insumosUtilizar[key].insumoId;
    let insumo;
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(
        (i) => i._id === insumo._id,
      );
      if (!yaExiste) {
        await this.setState((prev) => ({
          todasInsumos: [...prev.todasInsumos, insumo],
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId,
      );
    }
    this.setState({ loading: false });

    let costoMatriz = 0;
    let costoMatrizMaximo = 0;
    let costoMatrizMinimo = 0;
    let costoMatrizPromedio = 0;

    const nuevosInsumosUtilizar = insumosUtilizar.map((insumoU) => {
      if (insumoU?.insumoId) {
        const insumo = this.state.todasInsumos.find(
          (valueTI) => valueTI._id.toString() === insumoU.insumoId.toString(),
        );

        if (insumoU?.cantidad) {
          if (!insumo.calculo) {
            const { costoInsumo, costoMaximo, costoMinimo, costoPromedio } =
              this.calcularCostoInsumo(insumo, insumoU, metodoCosteoGeneral);

            costoMatriz += round6Decimals(
              costoInsumo * (insumoU.cantidad || 0),
            );
            costoMatrizMaximo += round6Decimals(
              costoMaximo * (insumoU.cantidad || 0),
            );
            costoMatrizMinimo += round6Decimals(
              costoMinimo * (insumoU.cantidad || 0),
            );
            costoMatrizPromedio += round6Decimals(
              costoPromedio * (insumoU.cantidad || 0),
            );

            return {
              ...insumoU,
              costo: costoInsumo,
              tipoDeInsumoId: insumo.tipoDeInsumoId,
              costoTotal: round6Decimals(costoInsumo * (insumoU.cantidad || 0)),
            };
          } else {
            return {
              ...insumoU,
              cantidad: insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje,
              tipoDeInsumoId: insumo.tipoDeInsumoId,
            };
          }
        } else {
          if (insumo.calculo) {
            return {
              ...insumoU,
              cantidad: insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje,
              tipoDeInsumoId: insumo.tipoDeInsumoId,
            };
          } else {
            const { costoInsumo } = this.calcularCostoInsumo(
              insumo,
              insumoU,
              metodoCosteoGeneral,
            );

            return {
              ...insumoU,
              costo: costoInsumo,
              tipoDeInsumoId: insumo.tipoDeInsumoId,
            };
          }
        }
      } else {
        return insumoU;
      }
    });

    const nuevosInsumosUtilizarConCalculo = nuevosInsumosUtilizar.map(
      (insumoU) => {
        if (insumoU?.insumoId) {
          const insumo = this.state.todasInsumos.find(
            (valueTI) => valueTI._id.toString() === insumoU.insumoId.toString(),
          );

          if (insumo.calculo) {
            let totalCostoTipoCalculo = 0;

            nuevosInsumosUtilizar.forEach((valueIU) => {
              if (
                valueIU.tipoDeInsumoId &&
                valueIU.insumoId.toString() !== insumo._id.toString() &&
                valueIU.tipoDeInsumoId?.toString() ===
                  insumo.tipoDeInsumoCalculoId.toString()
              ) {
                totalCostoTipoCalculo += valueIU.costoTotal;
              }
            });

            costoMatriz += round6Decimals(
              (totalCostoTipoCalculo *
                (insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje)) /
                100 || 0,
            );
            costoMatrizMaximo += round6Decimals(
              (totalCostoTipoCalculo *
                (insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje)) /
                100 || 0,
            );
            costoMatrizMinimo += round6Decimals(
              (totalCostoTipoCalculo *
                (insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje)) /
                100 || 0,
            );
            costoMatrizPromedio += round6Decimals(
              (totalCostoTipoCalculo *
                (insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje)) /
                100 || 0,
            );

            return {
              ...insumoU,
              costo: totalCostoTipoCalculo,
              costoTotal: round6Decimals(
                (totalCostoTipoCalculo *
                  (insumoU.cantidad ? insumoU.cantidad : insumo.porcentaje)) /
                  100 || 0,
              ),
            };
          } else {
            return insumoU;
          }
        } else {
          return insumoU;
        }
      },
    );

    this.formRef.current.setFieldsValue({
      costo: round2Decimals(costoMatriz),
      costoMaximo: round2Decimals(costoMatrizMaximo),
      costoMinimo: round2Decimals(costoMatrizMinimo),
      costoPromedio: round2Decimals(costoMatrizPromedio),
      insumosUtilizar: nuevosInsumosUtilizarConCalculo,
    });
    this.setState({
      costoMatriz,
      costoMatrizMaximo,
      costoMatrizMinimo,
      costoMatrizPromedio,
    });
  }

  render() {
    const { previewVisible, previewImage, previewTitle } = this.state;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={this.esNuevo ? "Agregar Matriz" : "Editar Matriz"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            !this.esNuevo && (
              <Space>
                {this.state.autorizado && !this.state.superado && (
                  <Popconfirm
                    title="Se creará una nueva versión editable de esta matriz. ¿Continuar?"
                    onConfirm={this.nuevaVersionMatriz.bind(this)}
                    okText="Si"
                    cancelText="No"
                  >
                    <ButtonItem
                      type="primary"
                      lila
                      className="botonAgregar"
                      icon={<PlusOutlined />}
                    >
                      Nueva versión
                    </ButtonItem>
                  </Popconfirm>
                )}
                {!this.esNuevo && (
                  <ButtonItem
                    type="primary"
                    rojo
                    onClick={() => {
                      this.setState({
                        modalMatriz: true,
                        modalMatrizId: this.props.id,
                      });
                    }}
                    icon={<FilePdfOutlined />}
                    className="botonAgregar"
                  >
                    Ver Pdf
                  </ButtonItem>
                )}
                {!this.state.autorizado &&
                  this.props.permisoAutorizarVersionMatriz && (
                    <Popconfirm
                      title="Se autorizará esta versión como la vigente. Ya no podrás editar su composición/precio directamente. ¿Continuar?"
                      onConfirm={this.autorizarMatriz.bind(this)}
                      okText="Si"
                      cancelText="No"
                    >
                      <ButtonItem
                        type="primary"
                        verde
                        className="botonAgregar"
                        icon={<CheckOutlined />}
                      >
                        Autorizar
                      </ButtonItem>
                    </Popconfirm>
                  )}
              </Space>
            )
          }
        />
        {this.state.versiones.length > 1 && (
          <Alert
            type="info"
            style={{ marginBottom: 10 }}
            message={
              <Space wrap>
                <span>Versiones de esta matriz:</span>
                {this.state.versiones.map((v) => (
                  <Tag
                    key={v._id}
                    color={
                      v._id.toString() === this.state.id?.toString()
                        ? "blue"
                        : "default"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (v._id.toString() === this.state.id?.toString())
                        return;
                      this.setState({ id: v._id }, () => this.consultarTodo());
                    }}
                  >
                    v{v.versionNumero}
                    {v.autorizado ? " ✓" : " (borrador)"}
                    {v.superado ? " (superada)" : ""}
                  </Tag>
                ))}
              </Space>
            }
          />
        )}
        {this.state.superado && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message="Esta es una versión superada (histórica) de la matriz, solo de lectura. Consulta la versión vigente en el selector de arriba."
          />
        )}
        {this.state.autorizado && !this.state.superado && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message="Esta matriz está autorizada y no puede modificarse directamente en su composición/precio. Usa 'Nueva versión' para crear una versión editable."
          />
        )}
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="matrizForm"
              layout
              bottom={
                <div style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                    {!this.state.autorizado && (
                      <ButtonItem
                        type="primary"
                        htmlType="submit"
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        {this.esNuevo ? "Agregar Matriz" : "Guardar Matriz"}
                      </ButtonItem>
                    )}
                  </Space>
                </div>
              }
              initialValues={{
                fechaCalculo: moment(),
                monedaCompraId: "60c7e4396465ad440c41c15a",
                retencionId: "613fef2a7ffb183b304924dc",
                insumosUtilizar: [{ insumoId: undefined, cantidad: 0 }],
              }}
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <GeneralFormLayout
                cards={[
                  {
                    title: "DATOS GENERALES",
                    lg: 24,
                    content: (
                      <>
                        <Row>
                          <Col span={12}>
                            <FormItem
                              label="Permitir Venta"
                              name="venta"
                              margin
                              labelCol={{ span: 12 }}
                              wrapperCol={{ span: 10 }}
                              initialValue={false}
                              valuePropName="checked"
                            >
                              <SwitchItem
                                disabled={this.state.autorizado}
                                onChange={(e) => this.onChangeVenta(e)}
                              />
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <FormItem
                              label="Permitir Compra"
                              name="compra"
                              margin
                              labelCol={{ span: 12 }}
                              wrapperCol={{ span: 10 }}
                              initialValue={false}
                              valuePropName="checked"
                            >
                              <SwitchItem disabled />
                            </FormItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12}>
                            <FormItem
                              name="codigo"
                              label="Código"
                              margin
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              pattern
                            >
                              <InputItem disabled placeholder="Código" />
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <FormItem
                              name="clave"
                              label="Clave"
                              margin
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                              pattern
                            >
                              <InputItem
                                disabled={this.state.autorizado}
                                placeholder="Clave"
                              />
                            </FormItem>
                          </Col>
                        </Row>
                        <FormItem
                          label="Cod. barras"
                          name="codigoBarras"
                          margin
                          labelCol={{ span: 3 }}
                          wrapperCol={{ span: 21 }}
                          pattern
                        >
                          <InputItem
                            disabled={this.state.autorizado}
                            placeholder="Codigo de barras"
                          />
                        </FormItem>
                        <FormItem
                          label="Descripción"
                          name="descripcion"
                          required
                          margin
                          labelCol={{ span: 3 }}
                          wrapperCol={{ span: 21 }}
                          pattern
                        >
                          <InputItem
                            disabled={this.state.autorizado}
                            placeholder="Descripción"
                            onBlur={this.onBlurDescripcion.bind(this)}
                          />
                        </FormItem>
                        <FormItem
                          label="Desc. Larga"
                          name="descripcionLarga"
                          required
                          margin
                          labelCol={{ span: 3 }}
                          wrapperCol={{ span: 21 }}
                          pattern
                        >
                          <TextAreaItem
                            disabled={this.state.autorizado}
                            placeholder="Descripción larga"
                          />
                        </FormItem>
                        <Row>
                          <Col span={8}></Col>
                          <Col span={8}>
                            <FormItem
                              label="Unidad"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <Input.Group compact>
                                <FormItem name="unidadId" required noStyle>
                                  <SelectItem
                                    disabled={this.state.autorizado}
                                    placeholder="Unidad"
                                    width={
                                      this.state.autorizado ? "100%" : "85%"
                                    }
                                  >
                                    {this.state.objetoUnidades}
                                  </SelectItem>
                                </FormItem>
                                {!this.state.autorizado && (
                                  <ButtonItem
                                    icon={<PlusOutlined />}
                                    style={{ width: "15%" }}
                                    onClick={this.abrirAgregarUnidad.bind(this)}
                                  />
                                )}
                              </Input.Group>
                            </FormItem>
                          </Col>
                          <Col span={8}>
                            <FormItem
                              name="fechaCalculo"
                              required
                              margin
                              labelCol={{ span: 12 }}
                              wrapperCol={{ span: 24 }}
                            >
                              <DatePickerItem
                                placeholder="Fecha de Calculo"
                                allowClear={false}
                                disabled
                              />
                            </FormItem>
                          </Col>
                        </Row>
                        {this.renderTipoMatriz()}
                        <Row>
                          <Col span={8}></Col>
                          <Col span={8}>
                            <FormItem
                              label="Máx"
                              name="max"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 24 }}
                              numberCero
                            >
                              <InputNumberItem
                                disabled={this.state.autorizado}
                                placeholder="Máximo"
                              />
                            </FormItem>
                          </Col>
                          <Col span={8}>
                            <FormItem
                              label="Mín"
                              name="min"
                              margin
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 24 }}
                              numberCero
                            >
                              <InputNumberItem
                                disabled={this.state.autorizado}
                                placeholder="Mín"
                              />
                            </FormItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={14}>
                            <FormItem
                              label="Proveedor"
                              name="proveedorDefaultId"
                              margin
                              labelCol={{ span: 5 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem
                                disabled={this.state.autorizado}
                                placeholder="Proveedor default"
                              >
                                {this.state.objetoProveedores}
                              </SelectItem>
                            </FormItem>
                          </Col>
                          <Col span={10}>
                            <FormItem
                              label="Compra Mínima"
                              name="catidadMinCompra"
                              margin
                              labelCol={{ span: 10 }}
                              wrapperCol={{ span: 18 }}
                              numberCero
                            >
                              <InputNumberItem
                                disabled={this.state.autorizado}
                                placeholder="Compra Mínima"
                              />
                            </FormItem>
                          </Col>
                        </Row>
                      </>
                    ),
                  },
                ]}
              />
              <div style={{ marginTop: 25 }}>
                <TabbedDynamicTable
                  formInstance={this.formRef}
                  defaultActiveKey={this.props.location?.state?.tabProduccion ? "produccion" : "insumosUtilizar"}
                  onTabChange={(key) => {
                    if (
                      key === "envio" &&
                      !this.state.todasMaterialesPeligrosos
                    ) {
                      this.consultarEnvio();
                    }
                  }}
                  tabs={[
                    {
                      key: "insumosUtilizar",
                      label: "Insumos a Utilizar",
                      forceRender: true,
                      customContent: (
                        <>
                          <FormItem
                            label="Metodo Costeo General"
                            name={"metodoCosteoGeneral"}
                            fieldKey={"metodoCosteoGeneral"}
                            numberCero
                            required
                            initialValue={2}
                          >
                            <SelectItem
                              disabled={this.state.autorizado}
                              sinBorde
                              width="100%"
                              placeholder="Metodo Costeo General"
                              onChange={(value) => {
                                let arrayValue =
                                  this.formRef.current.getFieldValue(
                                    "insumosUtilizar",
                                  );
                                arrayValue = arrayValue.map(
                                  (valueArrayValue) => {
                                    return {
                                      ...valueArrayValue,
                                      metodoCosteo: value,
                                    };
                                  },
                                );
                                this.formRef.current.setFieldsValue({
                                  insumosUtilizar: arrayValue,
                                });
                              }}
                            >
                              <Option value={1}>MAXIMO</Option>
                              <Option value={2}>PROMEDIO</Option>
                              <Option value={3}>MINIMO</Option>
                              <Option value={4}>ULTIMO</Option>
                            </SelectItem>
                          </FormItem>
                          <FormInitial.List name="insumosUtilizar">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.length > 0 ? (
                                  <h1 style={{ textAlign: "center" }}>
                                    Estos insumos seran utilizados para la
                                    matriz
                                  </h1>
                                ) : null}
                                <table className="table">
                                  {fields.length > 0 ? (
                                    <thead>
                                      <tr>
                                        <th
                                          className="th-border"
                                          style={{ width: this.props.ordenesMaquila ? "26%" : "35%" }}
                                        >
                                          Insumo
                                        </th>
                                        <th
                                          className="th-border"
                                          style={{ width: this.props.ordenesMaquila ? "10%" : "15%" }}
                                        >
                                          Cantidad
                                        </th>
                                        {this.props.ordenesMaquila && (
                                          <th
                                            className="th-border"
                                            style={{ width: "8%" }}
                                          >
                                            Medida (cm)
                                          </th>
                                        )}
                                        {this.props.ordenesMaquila && (
                                          <th
                                            className="th-border"
                                            style={{ width: "6%" }}
                                          >
                                            Principal
                                          </th>
                                        )}
                                        <th
                                          className="th-border"
                                          style={{ width: "15%" }}
                                        >
                                          Metodo Costeo
                                        </th>
                                        <th
                                          className="th-border"
                                          style={{ width: "15%" }}
                                        >
                                          Costo Unitario
                                        </th>
                                        <th
                                          className="th-border"
                                          style={{ width: "18%" }}
                                        >
                                          Costo Total
                                        </th>
                                        <th
                                          className="th-border"
                                          style={{ width: "2%" }}
                                        ></th>
                                      </tr>
                                    </thead>
                                  ) : null}
                                  {fields.map(
                                    (
                                      { key, name, fieldKey, ...restField },
                                      arrayKey,
                                    ) => (
                                      <tbody>
                                        <tr>
                                          <td className="td-border">
                                            <FormItem
                                              {...restField}
                                              name={[name, "insumoId"]}
                                              fieldKey={[arrayKey, "insumoId"]}
                                              required
                                              noStyle
                                            >
                                              <SelectInsumosItem
                                                empresaId={this.props.empresaId}
                                                headersToken={
                                                  this.props.headersToken
                                                }
                                                disabled={this.state.autorizado}
                                                sinBorde
                                                autoFocus
                                                dropdownMatchSelectWidth={600}
                                                width="100%"
                                                placeholder="Insumo"
                                                tiposInsumos={this.props.ordenesMaquila ? "generales" : "inventariablesEquivalenciasMatrices"}
                                                onChange={(
                                                  value,
                                                  insumoEncontrado,
                                                ) =>
                                                  this.onChangeInsumoCantidad(
                                                    value,
                                                    arrayKey,
                                                    insumoEncontrado,
                                                  )
                                                }
                                              />
                                            </FormItem>
                                          </td>
                                          <td className="td-border">
                                            <FormItem
                                              {...restField}
                                              noStyle
                                              shouldUpdate
                                            >
                                              {({ getFieldValue }) => {
                                                let arrayValue =
                                                  getFieldValue(
                                                    "insumosUtilizar",
                                                  );
                                                let calculo = false;
                                                if (
                                                  arrayValue[arrayKey]?.insumoId
                                                ) {
                                                  const insumo =
                                                    this.state.todasInsumos.find(
                                                      (valueTI) =>
                                                        valueTI._id.toString() ===
                                                        arrayValue[
                                                          arrayKey
                                                        ]?.insumoId.toString(),
                                                    );
                                                  calculo = !!insumo?.calculo;
                                                }
                                                return (
                                                  <FormItem
                                                    {...restField}
                                                    name={[name, "cantidad"]}
                                                    fieldKey={[
                                                      arrayKey,
                                                      "cantidad",
                                                    ]}
                                                    numberCero
                                                    noStyle
                                                    required
                                                    initialValue={undefined}
                                                  >
                                                    <InputNumberItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      sinBorde
                                                      porcentaje={calculo}
                                                      onChange={(value) =>
                                                        this.onChangeInsumoCantidad(
                                                          value,
                                                          arrayKey,
                                                        )
                                                      }
                                                    />
                                                  </FormItem>
                                                );
                                              }}
                                            </FormItem>
                                          </td>
                                          {this.props.ordenesMaquila && (
                                            <td className="td-border">
                                              <FormItem
                                                {...restField}
                                                name={[name, "medida"]}
                                                fieldKey={[arrayKey, "medida"]}
                                                noStyle
                                              >
                                                <InputNumberItem
                                                  disabled={this.state.autorizado}
                                                  sinBorde
                                                  placeholder="—"
                                                />
                                              </FormItem>
                                            </td>
                                          )}
                                          {this.props.ordenesMaquila && (
                                            <td className="td-border" style={{ textAlign: "center" }}>
                                              <FormItem
                                                {...restField}
                                                name={[name, "principal"]}
                                                fieldKey={[arrayKey, "principal"]}
                                                valuePropName="checked"
                                                noStyle
                                              >
                                                <CheckItem disabled={this.state.autorizado} />
                                              </FormItem>
                                            </td>
                                          )}
                                          <td className="td-border">
                                            <FormItem
                                              {...restField}
                                              name={[name, "metodoCosteo"]}
                                              fieldKey={[
                                                arrayKey,
                                                "metodoCosteo",
                                              ]}
                                              numberCero
                                              noStyle
                                              required
                                              initialValue={2}
                                            >
                                              <SelectItem
                                                disabled={this.state.autorizado}
                                                sinBorde
                                                width="100%"
                                                placeholder="Metodo Costeo"
                                                onChange={(value) =>
                                                  this.onChangeInsumoCantidad(
                                                    value,
                                                    arrayKey,
                                                  )
                                                }
                                              >
                                                <Option value={1}>
                                                  MAXIMO
                                                </Option>
                                                <Option value={2}>
                                                  PROMEDIO
                                                </Option>
                                                <Option value={3}>
                                                  MINIMO
                                                </Option>
                                                <Option value={4}>
                                                  ULTIMO
                                                </Option>
                                              </SelectItem>
                                            </FormItem>
                                          </td>
                                          <td className="td-border">
                                            <FormItem
                                              {...restField}
                                              name={[name, "costo"]}
                                              fieldKey={[arrayKey, "costo"]}
                                              numberCero
                                              noStyle
                                              required
                                              initialValue={undefined}
                                            >
                                              <InputNumberItem
                                                dineroDisabled
                                                disabled
                                                sinBorde
                                              />
                                            </FormItem>
                                          </td>
                                          <td className="td-border">
                                            <FormItem
                                              {...restField}
                                              name={[name, "costoTotal"]}
                                              fieldKey={[
                                                arrayKey,
                                                "costoTotal",
                                              ]}
                                              numberCero
                                              noStyle
                                              required
                                              initialValue={undefined}
                                            >
                                              <InputNumberItem
                                                dineroDisabled
                                                disabled
                                                sinBorde
                                              />
                                            </FormItem>
                                          </td>
                                          <td>
                                            {fields.length > 1 &&
                                              !this.state.autorizado && (
                                                <MinusCircleOutlined
                                                  onClick={() => remove(name)}
                                                  style={{
                                                    alignSelf: "center",
                                                    justifySelf: "center",
                                                  }}
                                                />
                                              )}
                                          </td>
                                        </tr>
                                      </tbody>
                                    ),
                                  )}

                                  <tbody key="T">
                                    <tr>
                                      <td
                                        className="td-border"
                                        style={{ textAlign: "left" }}
                                      >
                                        <p style={{ margin: 5 }}>Total:</p>
                                      </td>
                                      <td
                                        className="td-border"
                                        style={{ textAlign: "center" }}
                                      >
                                        <p style={{ margin: 5 }}></p>
                                      </td>
                                      <td
                                        className="td-border"
                                        style={{ textAlign: "center" }}
                                      >
                                        <p style={{ margin: 5 }}></p>
                                      </td>
                                      <td
                                        className="td-border"
                                        style={{ textAlign: "right" }}
                                      >
                                        <p style={{ margin: 5 }}></p>
                                      </td>
                                      <td
                                        className="td-border"
                                        style={{ textAlign: "right" }}
                                      >
                                        <p style={{ margin: 5 }}>
                                          {dineroDisabledMask(
                                            this.state.costoMatriz,
                                          )}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {!this.state.autorizado && (
                                  <FormItem noStyle>
                                    <ButtonItem
                                      style={{
                                        marginTop: 10,
                                        marginBottom: 10,
                                      }}
                                      type="dashed"
                                      onClick={() => {
                                        const metodoCosteoGeneral =
                                          this.formRef.current.getFieldValue(
                                            "metodoCosteoGeneral",
                                          );
                                        add({
                                          metodoCosteo: metodoCosteoGeneral,
                                        });
                                      }}
                                      block
                                      lessTime
                                      icon={<PlusOutlined />}
                                    >
                                      Agregar Campo
                                    </ButtonItem>
                                  </FormItem>
                                )}
                              </>
                            )}
                          </FormInitial.List>
                        </>
                      ),
                    },
                    ...(this.state.id && this.state.tipoMatriz !== 1
                      ? [
                          {
                            key: "produccion",
                            label: "Flujo y Producción",
                            customContent: <ProduccionMatriz insumoId={this.state.id} />,
                          },
                        ]
                      : []),
                    {
                      key: "preciosCostos",
                      label: "Precios y Costos",
                      forceRender: true,
                      customContent: (
                        <Row gutter={[16, 16]}>
                          <Col span={24}>
                            <FormItem
                              noStyle
                              shouldUpdate={(prev, curr) =>
                                prev.venta !== curr.venta
                              }
                            >
                              {({ getFieldValue }) => {
                                let venta = getFieldValue("venta");
                                if (venta) {
                                  return (
                                    <Row gutter={[16, 16]}>
                                      <DynamicCardForm
                                        title="LISTA DE PRECIOS"
                                        lg={24}
                                      >
                                        <FormInitial.List name="precios">
                                          {(fields, { add, remove }) => (
                                            <>
                                              {fields.map(
                                                (
                                                  {
                                                    key,
                                                    name,
                                                    fieldKey,
                                                    ...restField
                                                  },
                                                  otro,
                                                ) => (
                                                  <FormItem
                                                    key={key}
                                                    label={
                                                      "Precio " +
                                                      this.state.precios[key]
                                                        .nombre
                                                    }
                                                    margin
                                                    shouldUpdate
                                                  >
                                                    <Input.Group compact>
                                                      <FormItem
                                                        name={[
                                                          name,
                                                          "porcentaje",
                                                        ]}
                                                        required
                                                        numberCero
                                                        noStyle
                                                      >
                                                        <InputNumberItem
                                                          disabled={
                                                            this.state
                                                              .autorizado
                                                          }
                                                          porcentaje
                                                          sinWidth
                                                          onChange={(value) => {
                                                            let arrayValue =
                                                              this.formRef.current.getFieldValue(
                                                                "precios",
                                                              );
                                                            let valueCosto =
                                                              this.formRef.current.getFieldValue(
                                                                "costo",
                                                              );
                                                            if (!valueCosto)
                                                              return;
                                                            if (
                                                              this.state
                                                                .calcularPreciosSobre
                                                            ) {
                                                              arrayValue[
                                                                key
                                                              ].precio = (
                                                                (valueCosto *
                                                                  (100 +
                                                                    value)) /
                                                                100
                                                              ).toFixed(2);
                                                            } else {
                                                              arrayValue[
                                                                key
                                                              ].precio = (
                                                                valueCosto /
                                                                ((100 - value) /
                                                                  100)
                                                              ).toFixed(2);
                                                            }
                                                            this.formRef.current.setFieldsValue(
                                                              {
                                                                precios:
                                                                  arrayValue,
                                                              },
                                                            );
                                                          }}
                                                        />
                                                      </FormItem>
                                                      <FormItem
                                                        name={[name, "precio"]}
                                                        required
                                                        numberCero
                                                        noStyle
                                                      >
                                                        <InputNumberItem
                                                          disabled={
                                                            this.state
                                                              .autorizado
                                                          }
                                                          sinWidth
                                                          placeholder={
                                                            "Precio de Venta " +
                                                            this.state.precios[
                                                              key
                                                            ].nombre
                                                          }
                                                          dinero
                                                          onChange={(value) => {
                                                            let arrayValue =
                                                              this.formRef.current.getFieldValue(
                                                                "precios",
                                                              );
                                                            let valueCosto =
                                                              this.formRef.current.getFieldValue(
                                                                "costo",
                                                              );
                                                            if (!valueCosto)
                                                              return;
                                                            if (
                                                              this.state
                                                                .calcularPreciosSobre
                                                            ) {
                                                              arrayValue[
                                                                key
                                                              ].porcentaje = (
                                                                ((value -
                                                                  valueCosto) /
                                                                  valueCosto) *
                                                                100
                                                              ).toFixed(2);
                                                            } else {
                                                              arrayValue[
                                                                key
                                                              ].porcentaje = (
                                                                ((value -
                                                                  valueCosto) /
                                                                  value) *
                                                                100
                                                              ).toFixed(2);
                                                            }
                                                            this.formRef.current.setFieldsValue(
                                                              {
                                                                precios:
                                                                  arrayValue,
                                                              },
                                                            );
                                                          }}
                                                        />
                                                      </FormItem>
                                                    </Input.Group>
                                                  </FormItem>
                                                ),
                                              )}
                                            </>
                                          )}
                                        </FormInitial.List>
                                      </DynamicCardForm>
                                    </Row>
                                  );
                                } else {
                                  return null;
                                }
                              }}
                            </FormItem>
                          </Col>
                          <DynamicCardForm title="COSTOS" lg={24}>
                            <Row>
                              <Col span={24}>
                                <FormItem
                                  label="Costo"
                                  name="costo"
                                  required
                                  margin
                                  labelCol={{ span: 9 }}
                                  wrapperCol={{ span: 15 }}
                                  numberCero
                                >
                                  <InputNumberItem
                                    placeholder="Costo"
                                    dinero
                                    disabled
                                  />
                                </FormItem>
                                <FormItem
                                  label="Costo Maximo"
                                  name="costoMaximo"
                                  required
                                  margin
                                  labelCol={{ span: 9 }}
                                  wrapperCol={{ span: 15 }}
                                  numberCero
                                >
                                  <InputNumberItem
                                    placeholder="Costo Maximo"
                                    dinero
                                    disabled
                                  />
                                </FormItem>
                                <FormItem
                                  label="Costo Promedio"
                                  name="costoPromedio"
                                  required
                                  margin
                                  labelCol={{ span: 9 }}
                                  wrapperCol={{ span: 15 }}
                                  numberCero
                                >
                                  <InputNumberItem
                                    placeholder="Costo Promedio"
                                    dinero
                                    disabled
                                  />
                                </FormItem>
                                <FormItem
                                  label="Costo Minimo"
                                  name="costoMinimo"
                                  required
                                  margin
                                  labelCol={{ span: 9 }}
                                  wrapperCol={{ span: 15 }}
                                  numberCero
                                >
                                  <InputNumberItem
                                    placeholder="Costo Minimo"
                                    dinero
                                    disabled
                                  />
                                </FormItem>
                                {!this.state.autorizado && (
                                  <div style={{ textAlign: "center" }}>
                                    <ButtonItem
                                      type="primary"
                                      onClick={() => this.calcularCosto()}
                                    >
                                      Calcular Costo
                                    </ButtonItem>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </DynamicCardForm>
                        </Row>
                      ),
                    },
                    {
                      key: "archivoGrafico",
                      label: "Archivo Gráfico",
                      forceRender: true,
                      customContent: (
                        <Row gutter={[16, 16]}>
                          <DynamicCardForm title="ARCHIVO GRÁFICO" lg={24}>
                            <Row>
                              <Col span={8}>
                                <FormItem name="fotoPrincipal" margin>
                                  <Upload
                                    disabled={this.state.autorizado}
                                    showUploadList={{
                                      showRemoveIcon: !this.state.autorizado,
                                      showPreviewIcon: true,
                                      removeIcon: (file) => (
                                        <Popconfirm
                                          title="Seguro que quieres eliminar el archivo"
                                          onConfirm={() => {
                                            this.onRemoveFilePrincipal(file);
                                          }}
                                          okText="Si"
                                          cancelText="No"
                                        >
                                          <DeleteOutlined
                                            onClick={(e) => e.preventDefault()}
                                          />
                                        </Popconfirm>
                                      ),
                                    }}
                                    fileList={this.state.archivosPrincipal}
                                    customRequest={this.customRequestPrincipal.bind(
                                      this,
                                    )}
                                    onPreview={this.handlePreview}
                                  >
                                    {!this.state.autorizado && (
                                      <ButtonItem
                                        icon={<UploadOutlined />}
                                        style={{ padding: "0px 20px" }}
                                      >
                                        Foto Principal
                                      </ButtonItem>
                                    )}
                                  </Upload>
                                </FormItem>
                              </Col>
                              <Col span={8}>
                                <FormItem name="fichaTecnica" margin>
                                  <Upload
                                    disabled={this.state.autorizado}
                                    showUploadList={{
                                      showRemoveIcon: !this.state.autorizado,
                                      showPreviewIcon: true,
                                      removeIcon: (file) => (
                                        <Popconfirm
                                          title="Seguro que quieres eliminar el archivo"
                                          onConfirm={() => {
                                            this.onRemoveFileFicha(file);
                                          }}
                                          okText="Si"
                                          cancelText="No"
                                        >
                                          <DeleteOutlined
                                            onClick={(e) => e.preventDefault()}
                                          />
                                        </Popconfirm>
                                      ),
                                    }}
                                    fileList={this.state.archivosTecnica}
                                    customRequest={this.customRequestFicha.bind(
                                      this,
                                    )}
                                    multiple={true}
                                    onPreview={this.handlePreview}
                                  >
                                    {!this.state.autorizado && (
                                      <ButtonItem
                                        icon={<UploadOutlined />}
                                        style={{ padding: "0px 20px" }}
                                      >
                                        Ficha Técnica
                                      </ButtonItem>
                                    )}
                                  </Upload>
                                </FormItem>
                              </Col>
                              <Col span={8}>
                                <FormItem name="fotos" margin>
                                  <Upload
                                    disabled={this.state.autorizado}
                                    showUploadList={{
                                      showRemoveIcon: !this.state.autorizado,
                                      showPreviewIcon: true,
                                      removeIcon: (file) => (
                                        <Popconfirm
                                          title="Seguro que quieres eliminar el archivo"
                                          onConfirm={() => {
                                            this.onRemoveFileFotos(file);
                                          }}
                                          okText="Si"
                                          cancelText="No"
                                        >
                                          <DeleteOutlined
                                            onClick={(e) => e.preventDefault()}
                                          />
                                        </Popconfirm>
                                      ),
                                    }}
                                    fileList={this.state.archivosFotos}
                                    customRequest={this.customRequestFotos.bind(
                                      this,
                                    )}
                                    multiple={true}
                                    onPreview={this.handlePreview}
                                  >
                                    {!this.state.autorizado && (
                                      <ButtonItem
                                        icon={<UploadOutlined />}
                                        style={{ padding: "0px 45px" }}
                                      >
                                        Fotos
                                      </ButtonItem>
                                    )}
                                  </Upload>
                                </FormItem>
                              </Col>
                            </Row>
                          </DynamicCardForm>
                        </Row>
                      ),
                    },
                    {
                      key: "instruccionesElaboracion",
                      label: "Instrucciones de Elaboración",
                      forceRender: true,
                      customContent: (
                        <Row gutter={[16, 16]}>
                          <DynamicCardForm title="INSTRUCCIONES DE ELABORACIÓN" lg={24}>
                            <FormItem
                              name="instrucciones"
                              margin
                            >
                              <Upload
                                disabled={this.state.autorizado}
                                showUploadList={{
                                  showRemoveIcon: !this.state.autorizado,
                                  showPreviewIcon: true,
                                  removeIcon: (file) => (
                                    <Popconfirm
                                      title="Seguro que quieres eliminar el archivo"
                                      onConfirm={() => {
                                        this.onRemoveFileInstrucciones(file);
                                      }}
                                      okText="Si"
                                      cancelText="No"
                                    >
                                      <DeleteOutlined
                                        onClick={(e) => e.preventDefault()}
                                      />
                                    </Popconfirm>
                                  ),
                                }}
                                fileList={this.state.archivosInstrucciones}
                                customRequest={this.customRequestInstrucciones.bind(this)}
                                multiple={true}
                                onPreview={this.handlePreview}
                              >
                                {!this.state.autorizado &&
                                  <ButtonItem icon={<UploadOutlined />} style={{ padding: '0px 20px' }}>
                                    Adjuntar Archivo
                                  </ButtonItem>
                                }
                              </Upload>
                            </FormItem>
                          </DynamicCardForm>
                        </Row>
                      ),
                    },
                    {
                      key: "impuestosRetenciones",
                      label: "Impuestos y Retenciones",
                      forceRender: true,
                      customContent: (
                        <Row gutter={[16, 16]}>
                          <DynamicCardForm
                            title="IMPUESTOS Y RETENCIONES"
                            lg={24}
                          >
                            <Row>
                              <Col span={12}>
                                <h1 style={{ textAlign: "center" }}>
                                  Impuestos
                                </h1>
                                <FormInitial.List name="impuestos">
                                  {(fields, { add, remove }) => (
                                    <>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row>
                                          <Col span={22}>
                                            <FormItem
                                              name={[name, "impuestoId"]}
                                              fieldKey={[
                                                arrayKey,
                                                "impuestoId",
                                              ]}
                                              required
                                              margin
                                              noStyle
                                            >
                                              <SelectItem
                                                width="100%"
                                                disabled={
                                                  this.state.utilizado ||
                                                  this.state.autorizado
                                                }
                                                placeholder="Impuesto"
                                                onChange={this.onChangeImpuesto.bind(
                                                  this,
                                                )}
                                              >
                                                {this.state.objetoImpuestos}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2}>
                                            <div
                                              style={{ textAlign: "center" }}
                                            >
                                              <MinusCircleOutlined
                                                disabled={
                                                  this.state.utilizado ||
                                                  this.state.autorizado
                                                }
                                                onClick={() => {
                                                  remove(name);
                                                  this.onChangeImpuesto();
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                      {!this.state.impuestoCombustible ? (
                                        <div style={{ textAlign: "center" }}>
                                          <ButtonItem
                                            disabled={
                                              this.state.utilizado ||
                                              this.state.autorizado
                                            }
                                            type="primary"
                                            onClick={() => add()}
                                            icon={<PlusOutlined />}
                                          >
                                            Agregar
                                          </ButtonItem>
                                        </div>
                                      ) : null}
                                    </>
                                  )}
                                </FormInitial.List>
                              </Col>
                              <Col span={12}>
                                <h1 style={{ textAlign: "center" }}>
                                  Retenciones
                                </h1>
                                <FormInitial.List name="retenciones">
                                  {(fields, { add, remove }) => (
                                    <>
                                      {fields.map(({ name }, arrayKey) => (
                                        <Row>
                                          <Col span={22}>
                                            <FormItem
                                              name={[name, "retencionId"]}
                                              fieldKey={[
                                                arrayKey,
                                                "retencionId",
                                              ]}
                                              required
                                              margin
                                              noStyle
                                            >
                                              <SelectItem
                                                disabled={
                                                  this.state.utilizado ||
                                                  this.state.autorizado
                                                }
                                                width="100%"
                                                placeholder="Retención"
                                              >
                                                {this.state.objetoRetenciones}
                                              </SelectItem>
                                            </FormItem>
                                          </Col>
                                          <Col span={2}>
                                            <div
                                              style={{ textAlign: "center" }}
                                            >
                                              <MinusCircleOutlined
                                                disabled={
                                                  this.state.utilizado ||
                                                  this.state.autorizado
                                                }
                                                onClick={() => remove(name)}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                      <div style={{ textAlign: "center" }}>
                                        <ButtonItem
                                          disabled={
                                            this.state.utilizado ||
                                            this.state.autorizado
                                          }
                                          type="primary"
                                          onClick={() => add()}
                                          icon={<PlusOutlined />}
                                        >
                                          Agregar
                                        </ButtonItem>
                                      </div>
                                    </>
                                  )}
                                </FormInitial.List>
                              </Col>
                            </Row>
                          </DynamicCardForm>
                        </Row>
                      ),
                    },
                    {
                      key: "datosFiscales",
                      label: "Datos Fiscales",
                      forceRender: true,
                      customContent: (
                        <Row gutter={[16, 16]}>
                          <FormItem
                            noStyle
                            shouldUpdate={(prev, curr) =>
                              prev.venta !== curr.venta ||
                              prev.familiaId !== curr.familiaId
                            }
                          >
                            {({ getFieldValue }) => {
                              let venta = getFieldValue("venta");
                              let familiaId = getFieldValue("familiaId");
                              let familia;
                              if (familiaId) {
                                familia = this.state?.todasFamilia?.find(
                                  (valueTF) =>
                                    valueTF._id.toString() ===
                                    familiaId.toString(),
                                );
                              }
                              if (
                                venta &&
                                (!familia?.cuentaIngresoContadoId ||
                                  !familia?.cuentaIngresoCreditoId)
                              ) {
                                return (
                                  <Row gutter={[16, 16]}>
                                    <DynamicCardForm
                                      title="CUENTAS DE INGRESO"
                                      lg={24}
                                    >
                                      <Row>
                                        <Col span={24}>
                                          <FormItem
                                            label="Cuenta Contado"
                                            margin
                                          >
                                            <Input.Group compact>
                                              <FormItem
                                                name="cuentaIngresoContadoId"
                                                required
                                                noStyle
                                              >
                                                <SelectItem
                                                  disabled={
                                                    this.state.autorizado
                                                  }
                                                  placeholder="Cuenta Ingreso Contado"
                                                  width={
                                                    this.state.autorizado
                                                      ? "100%"
                                                      : "80%"
                                                  }
                                                >
                                                  {
                                                    this.state
                                                      .objetoCuentasContablesFinales
                                                  }
                                                </SelectItem>
                                              </FormItem>
                                              {!this.state.autorizado && (
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                  style={{ width: "20%" }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(
                                                    this,
                                                  )}
                                                />
                                              )}
                                            </Input.Group>
                                          </FormItem>
                                          <FormItem
                                            label="Cuenta Credito"
                                            margin
                                          >
                                            <Input.Group compact>
                                              <FormItem
                                                name="cuentaIngresoCreditoId"
                                                required
                                                noStyle
                                              >
                                                <SelectItem
                                                  disabled={
                                                    this.state.autorizado
                                                  }
                                                  placeholder="Cuenta Ingreso Credito"
                                                  width={
                                                    this.state.autorizado
                                                      ? "100%"
                                                      : "80%"
                                                  }
                                                >
                                                  {
                                                    this.state
                                                      .objetoCuentasContablesFinales
                                                  }
                                                </SelectItem>
                                              </FormItem>
                                              {!this.state.autorizado && (
                                                <ButtonItem
                                                  icon={<PlusOutlined />}
                                                  style={{ width: "20%" }}
                                                  blanco
                                                  onClick={this.abrirAgregarCuentaContable.bind(
                                                    this,
                                                  )}
                                                />
                                              )}
                                            </Input.Group>
                                          </FormItem>
                                        </Col>
                                      </Row>
                                    </DynamicCardForm>
                                  </Row>
                                );
                              } else {
                                return null;
                              }
                            }}
                          </FormItem>
                          <FormItem
                            noStyle
                            shouldUpdate={(prev, curr) =>
                              prev.venta !== curr.venta
                            }
                          >
                            {({ getFieldValue }) => {
                              let venta = getFieldValue("venta");
                              if (venta) {
                                return (
                                  <Row gutter={[16, 16]}>
                                    <DynamicCardForm title="CÓDIGO SAT" lg={24}>
                                      <Row>
                                        <Col span={24}>
                                          <FormItem
                                            label="Codigo Sat"
                                            name="codigoSatId"
                                            required
                                            margin
                                          >
                                            <SelectItem
                                              disabled={this.state.autorizado}
                                              mostrarCarga
                                              loading={
                                                this.state.buscarInfoCode
                                              }
                                              placeholder="Codigo Sat"
                                              onSearch={(value) => {
                                                this.onChangeCodigo(value);
                                              }}
                                            >
                                              <Option disabled>
                                                Escriba para buscar el codigo
                                              </Option>
                                              {this.state.objetoCodigoSat}
                                            </SelectItem>
                                          </FormItem>
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <ButtonItem
                                          style={{
                                            width: "50%",
                                            marginTop: "10px",
                                          }}
                                          onClick={() =>
                                            window.open(
                                              "http://pys.sat.gob.mx/PyS/catPyS.aspx",
                                              "_blank",
                                            )
                                          }
                                        >
                                          Conoce tu codigo sat
                                        </ButtonItem>
                                      </Row>
                                    </DynamicCardForm>
                                  </Row>
                                );
                              } else {
                                return null;
                              }
                            }}
                          </FormItem>
                          <DynamicCardForm title="DATOS FISCALES" lg={24}>
                            <Row>
                              <Col span={24}>
                                <FormItem
                                  label="Familia"
                                  margin
                                  labelCol={{ span: 3 }}
                                  wrapperCol={{ span: 21 }}
                                >
                                  <Input.Group compact>
                                    <FormItem name="familiaId" required noStyle>
                                      <SelectItem
                                        disabled={this.state.autorizado}
                                        placeholder="Familia"
                                        width={
                                          this.state.autorizado ? "100%" : "90%"
                                        }
                                      >
                                        {this.state.objetoFamilia}
                                      </SelectItem>
                                    </FormItem>
                                    {!this.state.autorizado && (
                                      <ButtonItem
                                        icon={<PlusOutlined />}
                                        style={{ width: "10%" }}
                                        onClick={this.abrirAgregarFamilia.bind(
                                          this,
                                        )}
                                      />
                                    )}
                                  </Input.Group>
                                </FormItem>
                                <FormItem
                                  label="Tipo Ins."
                                  margin
                                  name="tipoDeInsumoId"
                                  labelCol={{ span: 3 }}
                                  wrapperCol={{ span: 21 }}
                                >
                                  <SelectItem
                                    disabled={this.state.autorizado}
                                    placeholder="Tipo de Insumo"
                                    width="90%"
                                  >
                                    {this.state.objetoTipoDeInsumo}
                                  </SelectItem>
                                </FormItem>
                              </Col>
                            </Row>
                          </DynamicCardForm>
                        </Row>
                      ),
                    },
                    ...(this.props.envios
                      ? [
                          {
                            key: "envio",
                            label: "Envío",
                            forceRender: true,
                            customContent: (
                              <Spin spinning={this.state.loadingEnvios}>
                                <Row gutter={[16, 16]}>
                                  <DynamicCardForm
                                    title="DATOS MERCANCIA"
                                    lg={24}
                                  >
                                    <Row>
                                      <Col span={12}>
                                        <FormItem
                                          name="dimensiones"
                                          label="Dimensiones"
                                          margin
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          pattern
                                        >
                                          <InputItem
                                            disabled={this.state.autorizado}
                                            placeholder="Ejemplo:  59/40/36plg"
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Descripcion Materia"
                                          name="descripcionMateria"
                                          margin
                                          pattern
                                          labelCol={{ span: 8 }}
                                          wrapperCol={{ span: 16 }}
                                          tooltip={{
                                            title:
                                              "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario.",
                                          }}
                                        >
                                          <InputItem
                                            disabled={this.state.autorizado}
                                            placeholder="Descripcion Materia"
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Material Peligroso"
                                          name="materialPeligroso"
                                          margin
                                          initialValue={false}
                                          valuePropName="checked"
                                        >
                                          <SwitchItem
                                            disabled={this.state.autorizado}
                                          />
                                        </FormItem>
                                        <FormItem shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            if (
                                              getFieldValue("materialPeligroso")
                                            ) {
                                              return (
                                                <>
                                                  <FormItem
                                                    label="Material Peligroso"
                                                    name="materialPeligrosoId"
                                                    margin
                                                    required
                                                  >
                                                    <SelectItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Material Peligroso"
                                                      width="114%"
                                                    >
                                                      {
                                                        this.state
                                                          .objetoMaterialesPeligrosos
                                                      }
                                                    </SelectItem>
                                                  </FormItem>
                                                  <FormItem
                                                    name="numCAS"
                                                    label="Numero CAS"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el número Chemical Abstracts Service (CAS) con el que se identifica el compuesto químico de la sustancia tóxica.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Numero CAS"
                                                    />
                                                  </FormItem>
                                                </>
                                              );
                                            }
                                          }}
                                        </FormItem>
                                      </Col>
                                      <Col span={12}>
                                        <FormItem
                                          label="Peso en KGM"
                                          name="pesoEnKGM"
                                          margin
                                          numberCero
                                        >
                                          <InputNumberItem
                                            disabled={this.state.autorizado}
                                            placeholder="Peso en KGM"
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Clave STCC"
                                          name="claveSTCC"
                                          margin
                                          numberCero
                                          tooltip={{
                                            title:
                                              "Atributo opcional para expresar la clave de producto de la STCC (por sus siglas en inglés, Standard Transportation Commodity Code), cuando el medio de transporte utilizado para el traslado de los bienes y/o mercancías sea ferroviario.",
                                          }}
                                        >
                                          <InputNumberItem
                                            disabled={this.state.autorizado}
                                            placeholder="Clave STCC"
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Tipo Materia"
                                          name="tipoMateriaId"
                                          margin
                                          tooltip={{
                                            title:
                                              "Atributo condicional para expresar el estado de la materia o producto al realizar una operación de comercio exterior a través de los distintos medios de transporte.",
                                          }}
                                        >
                                          <SelectItem
                                            disabled={this.state.autorizado}
                                            placeholder="Tipo Materia"
                                            width="100%"
                                          >
                                            {this.state.objetoTiposMaterias}
                                          </SelectItem>
                                        </FormItem>
                                        <FormItem shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            if (
                                              getFieldValue("materialPeligroso")
                                            ) {
                                              return (
                                                <>
                                                  <FormItem
                                                    label="Embalaje"
                                                    name="embalajeId"
                                                    margin
                                                    required
                                                  >
                                                    <SelectItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Embalaje"
                                                      width="100%"
                                                    >
                                                      {
                                                        this.state
                                                          .objetoEmbalajes
                                                      }
                                                    </SelectItem>
                                                  </FormItem>
                                                  <FormItem
                                                    name="descripcionEmbalaje"
                                                    label="Descripcion Embalaje"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    required
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Ejemplo: Cajas de madera contrachapada"
                                                    />
                                                  </FormItem>
                                                </>
                                              );
                                            }
                                          }}
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                  <DynamicCardForm
                                    title="SECTOR COFEPRIS"
                                    lg={24}
                                  >
                                    <Row>
                                      <Col span={12}>
                                        <FormItem
                                          label="Sector COFEPRIS"
                                          name="sectorCOFEPRIS"
                                          margin
                                          initialValue={false}
                                          valuePropName="checked"
                                        >
                                          <SwitchItem
                                            disabled={this.state.autorizado}
                                          />
                                        </FormItem>
                                        <FormItem shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            if (
                                              getFieldValue("sectorCOFEPRIS")
                                            ) {
                                              return (
                                                <>
                                                  <FormItem
                                                    label="Sector COFEPRIS"
                                                    name="sectorCOFEPRISId"
                                                    margin
                                                    required
                                                  >
                                                    <SelectItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Sector COFEPRIS"
                                                      width="100%"
                                                    >
                                                      {
                                                        this.state
                                                          .objetoSectoresCOF
                                                      }
                                                    </SelectItem>
                                                  </FormItem>
                                                  <FormItem
                                                    name="nombreIngredienteActivo"
                                                    label="Ingrediente Activo"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el nombre común del ingrediente activo de los precursores, químicos de uso dual, plaguicidas o fertilizantes que se trasladan a través de los distintos medios de transporte",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Ingrediente Activo"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="nombreQuimico"
                                                    label="Nombre Quimico"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el nombre de la sustancia activa de los precursores, químicos de uso dual o sustancias tóxicas que se traslada a través de los distintos medios de transporte.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Nombre Quimico"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="denominacionGenericaProd"
                                                    label="Denominacion Generica"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el fármaco o la sustancia activa del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Denominacion Generica"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="denominacionDistintivaProd"
                                                    label="Denominacion Distintiva"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar la marca con la que se comercializa el producto o nombre que le asigna el laboratorio o fabricante a sus especialidades farmacéuticas con el fin de distinguirlas de otras similares del medicamento, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Denominacion Distintiva"
                                                    />
                                                  </FormItem>
                                                </>
                                              );
                                            }
                                          }}
                                        </FormItem>
                                      </Col>
                                      <Col span={12}>
                                        <FormItem shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            if (
                                              getFieldValue("sectorCOFEPRIS")
                                            ) {
                                              return (
                                                <>
                                                  <FormItem
                                                    name="fabricante"
                                                    label="Fabricante"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el nombre o razón social del establecimiento que realiza la fabricación o manufactura del medicamento, precursor, químico de uso dual, psicotrópico o estupefaciente que se traslada a través de los distintos medios de transporte.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Fabricante"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    label="Forma Farmaceutica"
                                                    name="formaFarmaceuticaId"
                                                    margin
                                                  >
                                                    <SelectItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Forma Farmaceutica"
                                                      width="100%"
                                                    >
                                                      {
                                                        this.state
                                                          .objetoFormasFarmaceuticas
                                                      }
                                                    </SelectItem>
                                                  </FormItem>
                                                  <FormItem
                                                    label="Condiciones Especiales"
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar la condición en la cual es necesario mantener el medicamento, precursor, químico de uso dual, psicotrópicos o estupefacientes durante el traslado y almacenamiento.",
                                                    }}
                                                    name="condicionEspecialId"
                                                    margin
                                                  >
                                                    <SelectItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Condiciones Especiales"
                                                      width="100%"
                                                    >
                                                      {
                                                        this.state
                                                          .objetoCondicionesEspeciales
                                                      }
                                                    </SelectItem>
                                                  </FormItem>
                                                  <FormItem
                                                    name="registroSanitarioFolioAutorizacion"
                                                    label="Registro Sanitario"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el registro sanitario o folio de autorización con el que cuenta la empresa para el traslado del medicamento, psicotrópico o estupefaciente.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Registro Sanitario"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="numRegSanPlagCOFEPRIS"
                                                    label="Numero Registro"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para expresar el número de registro sanitario para plaguicidas o fertilizantes cuya importación, comercialización y uso están permitidos en México, mismo que emite la Comisión Intersecretarial para el Control del Proceso y Uso de Plaguicidas, Fertilizantes y Sustancias Tóxicas (CICLOPLAFEST).",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Numero Registro"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="datosFabricante"
                                                    label="Datos Fabricante"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para registrar el país y nombre o razón social de quien produce o fabrica el ingrediente activo del plaguicida o fertilizante.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Datos Fabricante"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="datosFormulador"
                                                    label="Datos Formulador"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para registrar el país y nombre o razón social de quien formula el ingrediente activo del plaguicida o fertilizante.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Datos Formulador"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="datosMaquilador"
                                                    label="Datos Maquilador"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para registrar el país y nombre o razón social de quien maquila el ingrediente activo del plaguicida o fertilizante.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Datos Maquilador"
                                                    />
                                                  </FormItem>
                                                  <FormItem
                                                    name="usoAutorizado"
                                                    label="Uso Autorizado"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    pattern
                                                    tooltip={{
                                                      title:
                                                        "Atributo condicional para registrar el uso autorizado del plaguicida o fertilizante de acuerdo a la regulación del país.",
                                                    }}
                                                  >
                                                    <InputItem
                                                      disabled={
                                                        this.state.autorizado
                                                      }
                                                      placeholder="Uso Autorizado"
                                                    />
                                                  </FormItem>
                                                </>
                                              );
                                            }
                                          }}
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                  <DynamicCardForm
                                    title="DETALLE MERCANCIA"
                                    lg={24}
                                  >
                                    {this.state.unidadPeso ? (
                                      <p style={{ textAlign: "center" }}>
                                        Unidad de peso:{" "}
                                        {this.state.unidadPeso.nombre} -{" "}
                                        {
                                          this.state.unidadPeso.unidadSat
                                            .c_ClaveUnidad
                                        }
                                      </p>
                                    ) : null}
                                    <Row>
                                      <Col span={12}>
                                        <FormItem
                                          label="Peso Bruto"
                                          name="pesoBruto"
                                          margin
                                          numberCero
                                        >
                                          <InputNumberItem
                                            disabled={this.state.autorizado}
                                            placeholder="Peso Bruto"
                                          />
                                        </FormItem>
                                        <FormItem
                                          label="Peso Neto"
                                          name="pesoNeto"
                                          margin
                                          numberCero
                                        >
                                          <InputNumberItem
                                            disabled={this.state.autorizado}
                                            placeholder="Peso Neto"
                                          />
                                        </FormItem>
                                      </Col>
                                      <Col span={12}>
                                        <FormItem
                                          label="Peso Tara"
                                          name="pesoTara"
                                          margin
                                          numberCero
                                        >
                                          <InputNumberItem
                                            disabled={this.state.autorizado}
                                            placeholder="Peso Tara"
                                          />
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </DynamicCardForm>
                                </Row>
                              </Spin>
                            ),
                          },
                        ]
                      : []),
                  ]}
                />
              </div>
            </Form>
          </Spin>
        </div>
        <ModalItem
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
          spinning={false}
        >
          {previewImage && previewImage.startsWith("data:application/pdf") ? (
            <iframe
              title={previewTitle}
              src={previewImage}
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          ) : previewImage && previewImage.startsWith("data:image/") ? (
            <img alt="preview" style={{ width: "100%" }} src={previewImage} />
          ) : (
            <div style={{ textAlign: "center", padding: 20 }}>
              <p>No se puede previsualizar este tipo de archivo aquí.</p>
              <ButtonItem
                type="primary"
                onClick={() => window.open(previewImage, "_blank")}
              >
                Abrir archivo
              </ButtonItem>
            </div>
          )}
        </ModalItem>
        <AgregarUnidad
          visible={this.state.modalAgregarUnidad}
          cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)}
        />
        <AgregarFamilia
          visible={this.state.modalAgregarFamilia}
          cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)}
        />
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
            this,
          )}
        />
        <VerPdf
          visible={this.state.modalMatriz}
          id={this.state.id}
          cerrarModalPdf={() => this.setState({ modalMatriz: false })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
    ordenesMaquila: state.empresa.ordenesMaquila,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    envios: state.empresa.envios,
    // agregar permiso: Autorizar nueva versión de Matriz/Presupuesto PU
    permisoAutorizarVersionMatriz:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "",
      )?.activado,
  };
};

export default connect(mapStateToProps)(MatrizForm);
